export default __webpack_public_path__ + "images/a94102310596a77dfe86d32c8b7a72c6-PH_P_Desktop.jpg";